"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
require("rxjs/add/operator/shareReplay");
require("rxjs/add/operator/do");
require("rxjs/add/operator/map");
var credentialsKey = 'credentials';
var tokenKey = 'nano-token';
var renewTokenKey = 'nano-renew-token';
/**
 * Provides a base for authentication workflow.
 * The Credentials interface as well as login/logout methods should be replaced with proper implementation.
 */
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService(http) {
        var _this = this;
        this.http = http;
        this.loadCredentialsFromStorage();
        this.storageEventListener = function (storageEvent) {
            if (storageEvent.key === tokenKey) {
                _this._token = storageEvent.newValue;
            }
            if (storageEvent.key === renewTokenKey) {
                _this._renewToken = JSON.parse(storageEvent.newValue);
            }
            if (storageEvent.key === credentialsKey) {
                _this._credentials = JSON.parse(storageEvent.newValue);
            }
        };
        window.addEventListener('storage', this.storageEventListener);
    }
    Object.defineProperty(AuthenticationService.prototype, "credentials", {
        /**
         * Gets the user credentials.
         * @return {Credentials} The user credentials or null if the user is not authenticated.
         */
        get: function () {
            return this._credentials;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "token", {
        /**
         * Gets the user's token.
         * @return {string} The token or null if the user is not authenticated.
         */
        get: function () {
            return this._token;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthenticationService.prototype, "renewToken", {
        /**
         * Gets the user's renew token.
         * @return {string} The renew token or null if the user is not authenticated.
         */
        get: function () {
            return this._renewToken;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Authenticates the user.
     * @param {LoginContext} context The login parameters.
     * @return {Observable<Credentials>} The user credentials.
     */
    AuthenticationService.prototype.login = function (context) {
        var _this = this;
        return this.http
            .post('/api/login', { username: context.username, password: context.password }, { observe: 'response' })
            .do(function (res) { return _this.setCredentials(res.body.user, res.headers.get('Authorization').substr(7), res.body.renewToken, context.remember); })
            .shareReplay().map(function (res) { return res.body; });
    };
    /**
     * Logs out the user and clear credentials.
     * @return {Observable<boolean>} True if the user was logged out successfully.
     */
    AuthenticationService.prototype.logout = function () {
        this.setCredentials(null);
    };
    /**
     * Checks is the user is authenticated.
     * @return {boolean} True if the user is authenticated.
     */
    AuthenticationService.prototype.isAuthenticated = function () {
        return !!this.credentials;
    };
    /**
     * Returns true if the user has one of the specified UserRoles
     * @returns {boolean} True if user has the role
     */
    AuthenticationService.prototype.hasRole = function () {
        var roles = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            roles[_i] = arguments[_i];
        }
        return this.credentials ? roles.indexOf(this.credentials.role) !== -1 : false;
    };
    AuthenticationService.prototype.ngOnDestroy = function () {
        window.removeEventListener('storage', this.storageEventListener);
    };
    AuthenticationService.prototype.loadCredentialsFromStorage = function () {
        var savedCredentials = sessionStorage.getItem(credentialsKey) || localStorage.getItem(credentialsKey);
        var savedToken = sessionStorage.getItem(tokenKey) || localStorage.getItem(tokenKey);
        var savedRenewToken = sessionStorage.getItem(renewTokenKey) || localStorage.getItem(renewTokenKey);
        if (savedCredentials) {
            this._credentials = JSON.parse(savedCredentials);
        }
        this._token = savedToken || null;
        this._renewToken = savedRenewToken || null;
    };
    /**
     * Sets the user credentials.
     * The credentials may be persisted across sessions by setting the `remember` parameter to true.
     * Otherwise, the credentials are only persisted for the current session.
     * @param {Credentials=} credentials The user credentials.
     * @param {boolean=} remember True to remember credentials across sessions.
     */
    AuthenticationService.prototype.setCredentials = function (credentials, token, renewToken, remember) {
        this._credentials = credentials || null;
        this._token = token;
        this._renewToken = renewToken;
        if (credentials) {
            var storage = remember ? localStorage : sessionStorage;
            storage.setItem(credentialsKey, JSON.stringify(credentials));
            storage.setItem(tokenKey, token);
            storage.setItem(renewTokenKey, renewToken);
        }
        else {
            sessionStorage.removeItem(credentialsKey);
            localStorage.removeItem(credentialsKey);
            sessionStorage.removeItem(tokenKey);
            localStorage.removeItem(tokenKey);
            sessionStorage.removeItem(renewTokenKey);
            localStorage.removeItem(renewTokenKey);
        }
    };
    AuthenticationService.prototype.refreshToken = function () {
        var _this = this;
        return this.http
            .get('/api/user/renew', { observe: 'response' })
            .do(function (res) { return _this.setCredentials(res.body.user, res.headers.get('Authorization').substr(7), res.body.renewToken, !!localStorage.getItem(tokenKey)); })
            .shareReplay().map(function (res) { return res.body; });
    };
    AuthenticationService = tslib_1.__decorate([
        core_1.Injectable(),
        tslib_1.__metadata("design:paramtypes", [http_1.HttpClient])
    ], AuthenticationService);
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/app/core/authentication/authentication.service.ts
// module id = 69
// module chunks = 0